<template>
    <div>
	<div class="list-group no-border border-radius-2 mb-3">
		<div class="list-group-item list-group-item-primary">
			<strong>{{ $t('explore') }} </strong>
		</div>
        <div class="list-group-item">
            <NodeDrilldownSearch 
                view="search"
            />
        </div>
	</div>
    </div>
</template>

<script>
import NodeDrilldownSearch from "../../components/CurriculumMapping/NodeDrilldownSearch.vue";

export default {
	components: {
        NodeDrilldownSearch,
	},
    props: {
    },
    data() {
    	return {
    	}
    },
	mounted() {
	},
	methods: {
		
	}
};
</script>
